import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonNav, ModalController, PopoverController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { CustomerSelectionPaymentsTouchComponent } from '../customer-selection-payments-touch/customer-selection-payments-touch.component';

@Component({
  selector: 'app-customer-selection-payments-filter-mobile',
  templateUrl: './customer-selection-payments-filter-mobile.component.html',
  styleUrls: ['./customer-selection-payments-filter-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSelectionPaymentsFilterMobileComponent extends CustomerSelectionPaymentsTouchComponent {
  constructor(
    modalController: ModalController,
    popoverController: PopoverController,
    platformService: PlatformService,
    private ionNav: IonNav,
  ) {
    super(modalController, popoverController, platformService);
  }

  navigateBack() {
    this.ionNav.pop();
  }
}
